import { omit } from '@helpers/data';

import { WithdrawalsDeleteExchangeRateReducer } from './types';

export const withdrawalsDeleteExchangeRateReducer: WithdrawalsDeleteExchangeRateReducer =
  (state, action) => {
    const { id } = action.payload;

    return {
      ...state,
      withdrawalsExchangeRatesProcessedItems: omit(
        state.withdrawalsExchangeRatesProcessedItems,
        id
      ),
    };
  };
